module.exports = __webpack_public_path__ + "img/module_ir301.cd35560e.png";